// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Forbidden_pageContainer__1qbsF fit-viewport-body children-center"};